import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Stack,
  Text,
  Spinner,
  Flex,
  IconButton,
  useToast,
} from '@chakra-ui/react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { ArrowForwardIcon, ArrowBackIcon } from '@chakra-ui/icons';
import Api from '../api/ApiUrl'

const fetchNotifications = async (page) => {
  const { data } = await axios.get(`${Api}/api/v1/admin-notifications?page=${page}&limit=20`);
  return data.data.data;
};

const markAllAsSeen = async () => {
  await axios.patch(`${Api}/api/v1/admin-notifications/${55}/seen`);
};

const Notifications = () => {
  const [page, setPage] = React.useState(1);
  const toast = useToast();
  const queryClient = useQueryClient();

  const { data, isLoading, isError, error } = useQuery(
   
    ['notifications', page],
    () => fetchNotifications(page),
    { keepPreviousData: true }
  );

  const mutation = useMutation(markAllAsSeen, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications');
      toast({ title: 'All notifications marked as seen.', status: 'success' });
    },
  });

  useEffect(() => {
    mutation.mutate();
  }, []);

  if (isLoading) return <Spinner />;
  if (isError) return <Text>Error: {error.message}</Text>;

  return (
    <Box maxW="600px" mx="auto" p={4}>
      <Text fontSize="2xl" mb={4}>Notifications</Text>
      <Stack spacing={4}>
        {data.map((notification) => (
          <Box
            key={notification._id}
            p={4}
            borderRadius="md"
            bg={notification.seen ? 'gray.100' : 'blue.50'}
            boxShadow="md"
          >
            <Text fontWeight="bold">{notification.title}</Text>
            <Text>{notification.message}</Text>
            <Text fontSize="sm" color="gray.500">
              {new Date(notification.createdAt).toLocaleString()}
            </Text>
          </Box>
        ))}
      </Stack>

      <Flex justifyContent="space-between" mt={4}>
        <IconButton
          onClick={() => setPage((old) => Math.max(old - 1, 1))}
          isDisabled={page === 1}
          icon={<ArrowBackIcon />}
          aria-label="Previous page"
        />
        <Text>Page {page}</Text>
        <IconButton
          onClick={() => setPage((old) => old + 1)}
          isDisabled={data.length < 20}
          icon={<ArrowForwardIcon />}
          aria-label="Next page"
        />
      </Flex>
    </Box>
  );
};

export default Notifications;
